// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__-VRJI","EnvWarning":"Logo_EnvWarning__xHw1-"};